<!--
Copyright 2022 Carnegie Mellon University. All Rights Reserved.
Released under a MIT (SEI)-style license, please see LICENSE.md in the
project root for license information or contact permission@sei.cmu.edu for full terms.
-->

<div class="full-width">
  <div class="user-list-container mat-elevation-z8">
    <mat-toolbar class="background">
      <mat-toolbar-row>
        <mat-icon class="mdi-24px" fontIcon="mdi-account-multiple"></mat-icon>
        <p>Users</p>
      </mat-toolbar-row>
      <mat-toolbar-row>
        <mat-form-field class="w-50">
          <input matInput [formControl]="filterControl" placeholder="Search" autocomplete="off" />
          @if (filterControl.value) {
          <button mat-icon-button matSuffix (click)="clearFilter()" title="Clear Search">
            <mat-icon style="transform: scale(0.85);" fontIcon="mdi-close-circle-outline"></mat-icon>
          </button>
          }
        </mat-form-field>
        <mat-paginator #userPaginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Select page of users"></mat-paginator>
      </mat-toolbar-row>
    </mat-toolbar>

    <mat-table class="table-all-users" #table [dataSource]="userDataSource" matSort
      (matSortChange)="onSortChange($event)">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>User Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (element.name !== null) {
          <div>{{ element.name }}</div>
          }
          @if (element.name === null) {
          <div>{{ element.id }}</div>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div>
            <button mat-icon-button (click)="addUserToUnit(element)" title="Add {{ element.name }}" [disabled]="!canManage">
              <mat-icon class="mdi-24px" fontIcon="mdi-plus-circle-outline" title="Add {{ element.name }}"></mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedUserColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedUserColumns"></mat-row>
    </mat-table>

    @if (userDataSource.filteredData.length === 0) {
    <div>No results found</div>
    }
  </div>

  <div class="spacer">&nbsp;</div>

  <div class="unit-list-container mat-elevation-z8">
    <mat-toolbar class="background">
      <mat-toolbar-row>
        <mat-icon class="mdi-24px" fontIcon="mdi-account-group"></mat-icon>
        <p>Unit Members</p>
      </mat-toolbar-row>
      <mat-toolbar-row>
        <mat-form-field class="w-50">
          <input matInput [formControl]="unitUserFilterControl" placeholder="Search" autocomplete="off" />
          @if (unitUserFilterControl.value) {
          <button mat-icon-button matSuffix (click)="clearUnitUserFilter()" title="Clear Search">
            <mat-icon style="transform: scale(0.85);" fontIcon="mdi-close-circle-outline"></mat-icon>
          </button>
          }
        </mat-form-field>
        <mat-paginator #unitUserPaginator [pageSizeOptions]="[10, 25, 50, 100]" aria-label="Select page of unit users"></mat-paginator>
      </mat-toolbar-row>
    </mat-toolbar>

    <mat-table class="table-all-users" #table [dataSource]="unitUserDataSource" matSort
      (matSortChange)="onSortUnitChange($event)">
      <ng-container matColumnDef="name">
        <mat-header-cell *matHeaderCellDef mat-sort-header>User Name</mat-header-cell>
        <mat-cell *matCellDef="let element">
          @if (element.name !== null) {
          <div>{{ element.name }}</div>
          }
          @if (element.name === null) {
          <div>{{ element.id }}</div>
          }
        </mat-cell>
      </ng-container>

      <ng-container matColumnDef="id">
        <mat-header-cell *matHeaderCellDef>&nbsp;</mat-header-cell>
        <mat-cell *matCellDef="let element">
          <div>
            <button mat-icon-button (click)="removeUserFromUnit(element)" title="Remove {{ element.name }}" [disabled]="!canManage">
              <mat-icon class="mdi-24px" fontIcon="mdi-minus-circle-outline"
                title="Remove {{ element.name }}"></mat-icon>
            </button>
          </div>
        </mat-cell>
      </ng-container>

      <mat-header-row *matHeaderRowDef="displayedUserColumns"></mat-header-row>
      <mat-row *matRowDef="let row; columns: displayedUserColumns"></mat-row>
    </mat-table>
  </div>
</div>
